import { Language } from "../data/constants";
import { ApiResponse, customFetch } from "./CustomFetch";

export const setUpUser = () =>
  customFetch("me/set-up", {
    method: "PUT",
  });

export const fetchMyUiLanguage = () => {
  return customFetch("me/ui-language")
    .then((response) => response.json() as Promise<ApiResponse<Language>>)
    .then((jsonResponse) => jsonResponse.data);
};
